{
  "common": {
    "cancel": "取消",
    "create": "创建",
    "creating": "创建中…",
    "retry": "重试",
    "readOnlyBanner": "此测试工作区为只读。所有内容仍可查看——过往运行、运行结果以及全部配置——但新建与编辑已关闭。",
    "readOnlyReason": "此测试工作区为只读，因此无法更改。",
    "noWriteBanner": "你可以查看此测试工作区中的所有内容——数据、用例、过往运行和结果——但编辑、上传和运行需要在该模型上获得“协作者”权限。模型所有者或管理员可以授予该权限。",
    "noWriteReason": "修改此测试工作区需要在该模型上获得“协作者”权限。",
    "stillWorking": "仍在处理…"
  },
  "home": {
    "title": "测试场",
    "subtitle": "针对您的数据构建并运行测试流水线。",
    "workspacesHeading": "测试工作区",
    "newWorkspace": "新建工作区",
    "empty": "尚无测试工作区。",
    "createFirst": "创建您的第一个工作区",
    "cardMetaTables_one": "{{count}} 个表",
    "cardMetaTables_other": "{{count}} 个表",
    "cardMetaCases_one": "{{count}} 个测试用例",
    "cardMetaCases_other": "{{count}} 个测试用例",
    "open": "打开",
    "delete": "删除",
    "deleteTitle": "删除工作区？",
    "deleteBody": "这将永久删除“{{name}}”及其全部数据、测试用例和运行记录。",
    "backToList": "返回工作区列表",
    "nameLabel": "工作区名称",
    "namePlaceholder": "例如：年度 PD 验证",
    "scopeLabel": "领域",
    "scopeChange": "更改",
    "scopeGenericNotAllowed": "测试工作区不能使用通用任务——请从菜单中选择一个领域。",
    "scopeHint": "本工作区的方法论范围。创建后无法更改。",
    "outputLanguage": "回复语言"
  },
  "rail": {
    "data": "数据",
    "dataCount": "已确认 {{confirmed}}/{{total}}",
    "testCases": "测试用例",
    "newCase": "新建测试用例",
    "confirmFirst": "请先确认至少一个表，然后添加测试用例。",
    "noCases": "尚无测试用例。",
    "caseNameLabel": "测试用例名称",
    "caseNamePlaceholder": "例如：基线运行",
    "pickCase": "请选择一个测试用例以继续。"
  },
  "case": {
    "saveWebhook": "保存",
    "savingWebhook": "保存中…",
    "webhookHint": "从现在起启动的运行，完成后会将结果发送到此 https 地址。留空则不发送任何通知。",
    "webhookLabel": "Webhook URL",
    "webhookPlaceholder": "https://example.com/hooks/reggie"
  },
  "stage": {
    "data": {
      "tab": "数据"
    },
    "discover": {
      "tab": "探索"
    },
    "build": {
      "tab": "构建"
    },
    "run": {
      "tab": "运行"
    }
  },
  "discover": {
    "openingTitle": "今天我们想做什么？",
    "openingSubtitle": "描述您的目标。我会检索合适的方法论和函数，并基于您已确认的数据提出流水线方案。",
    "composerPlaceholder": "描述您想测试的内容…",
    "composerBusy": "正在等待当前回复…",
    "composerBusyHint": "一次一条消息——正在等待助手完成回复。",
    "send": "发送",
    "thinking": "处理中…",
    "cancel": "停止",
    "turnFailed": "助手未能完成该操作。请重试。",
    "failure": {
      "agent_max_rounds": "助手在完成前已用完步骤。请尝试缩小请求范围。",
      "agent_timeout": "助手响应时间过长。请重试。",
      "agent_refused": "助手拒绝了此请求。请尝试换一种说法。",
      "llm_infrastructure": "助手暂时不可用。请稍后重试。",
      "tool_failed": "助手无法获取所需的数据。请重试。",
      "tool_result_shape_invalid": "助手收到了无法识别的数据。请重试；如果问题持续，请联系支持人员。",
      "discovery_empty_answer": "助手没有生成回复。请重试。",
      "discovery_incomplete": "助手的回复被截断。请重试。",
      "config_generation_failed": "流水线已保存，但未能填写其设置。请重试以完成设置。",
      "config_incomplete": "流水线已保存，但其设置仅部分填写。请重试以完成设置。",
      "config_draft_missing": "请先描述流水线，然后即可填写其设置。",
      "node_already_resolved": "此模块已有代码。请选择“重新生成代码”来替换。"
    },
    "turnCancelled": "已停止。",
    "noAnswer": "未生成任何回复。",
    "activityLines_other": "{{count}} 个检索步骤",
    "activityLines_one": "{{count}} 个检索步骤",
    "proposalTitle": "流水线方案",
    "proposalViewInBuild": "在构建中查看",
    "attachTooltip": "附加一份支持文档",
    "attachedChip": "📎 {{filename}}",
    "extracting": "正在读取文档…",
    "enqueued": "消息已发送，正在等待助手…",
    "micStart": "开始语音输入",
    "micStop": "结束语音输入",
    "micCancel": "取消语音输入",
    "micRequestingPermission": "请允许使用麦克风…",
    "micListening": "正在聆听…",
    "micSpeechDetected": "正在聆听您的消息…",
    "micTranscribing": "正在转写…",
    "micDone": "语音消息已发送",
    "micLevel": "麦克风音量",
    "micUnsupported": "此浏览器不支持语音输入。"
  },
  "build": {
    "emptyTitle": "尚无流水线",
    "emptySubtitle": "请在探索对话中设计流水线——助手提出方案后，即会在此处显示以供审阅和优化。",
    "unboundInput": "未绑定的输入",
    "placeholder": "需要代码",
    "portArgs": "输入",
    "packageMembers": "输出",
    "kind": {
      "input": "数据输入",
      "bf": "函数",
      "custom": "自定义节点"
    },
    "validationHeading": "校验",
    "issueGoToNode": "{{issue}} — 打开此块",
    "issueGoToEdge": "{{issue}} — 打开此连接",
    "issuePipelineLevelHeading": "整个流水线",
    "valid": "有效",
    "validHint": "此流水线有效，可以运行。",
    "paletteHeading": "添加",
    "addCustomNode": "自定义节点",
    "paletteHint": "基础函数由助手在探索对话中添加。",
    "lockedBanner": "助手正在更新此流水线。在其完成前，编辑已暂停。",
    "invalid_other": "{{count}} 个问题",
    "invalid_one": "{{count}} 个问题",
    "paletteFunctions": "函数",
    "paletteSearch": "搜索函数…",
    "paletteEmpty": "没有匹配的函数。",
    "addFunction": "添加到流水线",
    "autoArrange": "自动排列",
    "paletteDragHint": "将函数拖到画布上。",
    "dockedChatTitle": "助手",
    "expandChat": "显示助手",
    "collapseChat": "隐藏助手",
    "resizeChat": "调整助手面板大小",
    "heldInvalidBanner": "此更改尚未保存——请解决高亮显示的问题以保存。",
    "invalidDraftBanner": "已保存的流水线存在未解决的问题——请先修复才能运行。",
    "paletteUncategorized": "其他",
    "editor": {
      "close": "关闭",
      "inputMappings": "连接",
      "noInputSlots": "此块不接受任何输入。",
      "noIncomingEdges": "尚无连接到此块的连线。",
      "editMapping": "编辑映射",
      "emptyMapping": "尚未映射任何输入。",
      "parameters": "参数",
      "noEditableParams": "此函数没有可编辑的参数。",
      "functionNotInCatalog": "此函数已不在该工作区的目录中。",
      "missingWidgetKind": "“{{name}}”无法在此处编辑。如需更改，请联系支持人员。",
      "pickColumn": "选择由已连接上游块生成的列。",
      "columnFreeText": "输入列名——连接输入后可从上游列中选择。",
      "enumFreeText": "未声明选项——请输入一个值。",
      "unset": "未设置",
      "defaultPlaceholder": "默认值：{{value}}",
      "effectiveDefault": "未填写——实际执行时将使用架构默认值 {{value}}。",
      "deleteNode": "删除块",
      "editCustomCode": "重新生成代码",
      "subKeyCompleteness": "已填写 {{filled}}/{{total}} 个必填字段"
    },
    "mapping": {
      "title": "连接映射",
      "unmapped": "未映射",
      "incompatible": "类型不匹配——验证器会标记此问题。",
      "save": "保存映射",
      "deleteEdge": "删除连接",
      "producerUnknown": "此块的输出尚未加入目录，因此无法在此列出其成员。",
      "consumerUnknown": "此块的输入尚未声明，因此无法在此列出其参数。",
      "noArgs": "此块不接受任何输入。"
    },
    "validWithWarnings_one": "有效 — 还有 {{count}} 项待完成",
    "validWithWarnings_other": "有效 — 还有 {{count}} 项待完成",
    "configPending": "配置待完成",
    "configPendingBanner": "结构已保存——配置尚未完成，此流水线暂时无法运行。",
    "configPassRun": "运行配置阶段",
    "configPassStarted": "已启动——请在对话中跟进",
    "configPassRequest": "对当前草稿运行配置阶段。"
  },
  "customNode": {
    "titleResolve": "完善自定义节点",
    "subtitle": "描述逻辑，由助手编写节点；或上传现有代码进行适配。",
    "turnActive": "助手正忙。请在当前回复完成后重试。",
    "promptLabel": "此节点应做什么？",
    "promptPlaceholder": "例如：计算参考评分分布与当前评分分布之间的群体稳定性指数。",
    "chooseFile": "上传代码",
    "uploadAction": "上传并规范化",
    "generateAction": "生成代码",
    "forNode": "用于节点 {{id}}",
    "forNew": "作为新步骤",
    "generateRequest": "请生成一个自定义节点{{target}}：",
    "uploadRequest": "请将上传的代码规范化为一个自定义节点{{target}}（文件：{{name}}）："
  },
  "run": {
    "heading": "运行",
    "runButton": "运行流水线",
    "running": "运行中…",
    "cancel": "取消运行",
    "versionLabel": "运行 v{{n}}",
    "pastRunView": "正在查看历史运行",
    "emptyHint": "运行此流水线，即可在此查看执行状态和结果。",
    "inFlight": "运行中…",
    "blockProgress": "{{done}}/{{total}} 个步骤",
    "failedGeneric": "运行失败。请检查流水线后重试。",
    "cancelledHint": "此运行已取消。",
    "resultsHeading": "结果",
    "sendToProject": "发送到项目",
    "sendToProjectToolLabel": "测试场运行",
    "noPreview": "此产物暂无可用预览。",
    "previewTruncated": "显示前 {{shown}} 行，共 {{total}} 行。",
    "previewFirstRows": "显示前 {{shown}} 行。",
    "artifacts": "产物",
    "artifact": "产物",
    "download": "下载",
    "pastRuns": "历史运行",
    "timelineHeading": "执行步骤",
    "noArtifacts": "此运行未产生任何产物。",
    "preview": "预览",
    "hidePreview": "隐藏预览",
    "block": {
      "status": {
        "succeeded": "成功",
        "failed": "失败",
        "skipped": "已跳过",
        "running": "运行中",
        "pending": "待执行",
        "unknown": "未知"
      },
      "pendingSummary_one": "还有 {{count}} 个步骤待执行",
      "pendingSummary_other": "还有 {{count}} 个步骤待执行",
      "outputs": "输出",
      "noOutputs": "此步骤未产生任何输出。",
      "skippedUpstream": "前序步骤失败，此步骤未执行。",
      "skippedCancelled": "运行在此步骤执行前已取消。",
      "error": {
        "generic": "此步骤失败。",
        "validation_failed": "此步骤的配置未通过校验。",
        "unknown_param": "此步骤收到了无法识别的参数。",
        "unresolved_input_binding": "此步骤的输入无法关联到前序步骤的输出。",
        "input_load_failed": "此步骤的输入数据加载失败。",
        "bf_invocation_failed": "此步骤的函数在运行时失败。",
        "invalid_return": "此步骤的函数返回了意外结果。",
        "artifact_write_failed": "此步骤的输出保存失败。",
        "kernel_unreachable": "无法连接执行引擎。",
        "block_timeout": "此步骤耗时过长，已超时。",
        "skipped_upstream_failed": "前序步骤失败，此步骤未执行。",
        "cancelled": "运行在此步骤完成前已取消。",
        "user_cancelled": "运行在此步骤执行前已取消。"
      }
    },
    "status": {
      "queued": "排队中",
      "executing": "运行中",
      "running": "运行中",
      "succeeded": "成功",
      "failed": "失败",
      "cancelled": "已取消",
      "stale": "已停止"
    },
    "error": {
      "validation_failed": "此管道未通过校验。请修正标记的步骤后重新运行。",
      "bf_invocation_failed": "某个步骤的函数在运行时失败。请检查标记的步骤后重试。",
      "input_load_failed": "某个步骤无法加载其输入数据。请检查您的数据后重试。",
      "unresolved_input_binding": "某个步骤的输入未连接到上游步骤的输出。请检查连接后重试。",
      "block_timeout": "某个步骤耗时过长已超时。请重试。",
      "kernel_unreachable": "无法连接到执行引擎。请重试。",
      "invalid_return": "某个步骤返回了意外的结果。请检查管道后重试。",
      "artifact_write_failed": "某个步骤的输出无法保存。请重试。",
      "unknown_param": "某个步骤收到了无法识别的设置。请检查该步骤的配置后重试。",
      "node_timeout": "某个步骤超出了允许的运行时间，已被停止。请重新运行以从该步骤继续——之前的步骤会保留结果。",
      "kernel_unresponsive": "执行引擎在某个步骤运行期间停止响应。请重新运行以从该步骤继续——之前的步骤会保留结果。",
      "watchdog_stranded": "运行已停止响应且无法恢复。请重新运行。"
    }
  },
  "data": {
    "dropzoneTitle": "添加您的数据",
    "dropzoneSubtitle": "拖放文件，或选择 .parquet、.csv 或 .xlsx 文件。",
    "chooseFiles": "选择文件",
    "addData": "添加数据",
    "catalogHeading": "已确认 {{confirmed}}/{{total}}",
    "pollingAria": "正在处理数据表",
    "singleTable": "数据表",
    "selectTable": "选择一个表以查看其详细信息。",
    "uploadQueued": "已收到上传——正在准备您的数据。",
    "rowColCount": "{{rows}} 行 · {{cols}} 列",
    "reEnrich": "重新分析",
    "confirm": "确认",
    "attentionTitle": "此表需要处理",
    "attentionGeneric": "准备此表时出现问题。请尝试重新分析。",
    "processingHint": "正在准备此表…",
    "confirmedHint": "此表已确认，可用于测试用例。",
    "descriptionLabel": "描述",
    "descriptionPlaceholder": "此表代表什么？",
    "schemaTab": "结构",
    "sampleTab": "样本",
    "colName": "列",
    "colType": "类型",
    "colRole": "角色",
    "colMeaning": "含义",
    "roleUnset": "未设置",
    "noColumns": "未检测到任何列。",
    "notDescribed": "未描述",
    "saveOverrides": "保存更改",
    "noSample": "无可用的样本行。"
  },
  "role": {
    "identifier": "标识符",
    "time_index": "时间索引",
    "target": "目标",
    "feature": "特征",
    "reference": "参考",
    "other": "其他"
  },
  "status": {
    "queuedEnumerate": "排队中",
    "enumerating": "读取文件",
    "queuedParse": "排队中",
    "parsing": "转换中",
    "queuedEnrich": "排队中",
    "enriching": "分析中",
    "ready": "就绪",
    "attention": "需要处理",
    "confirmed": "已确认",
    "cancelled": "已取消",
    "deleted": "已删除",
    "unknown": "未知"
  },
  "validation": {
    "generic": "此步骤存在配置问题。",
    "input_table_unbound": "此输入尚未绑定到已确认的表。",
    "custom_node_unresolved": "此自定义节点仍需提供代码。",
    "custom_io_undeclared": "此自定义节点尚未声明其输入和输出。",
    "slot_name_invalid": "自定义节点的某个输入或输出名称无法使用。请使用不含斜杠、且不只由点组成的名称。",
    "unmapped_required_arg": "有必需的输入未连接。",
    "unknown_output_member": "某个连接引用了此步骤并不产生的输出。",
    "unknown_input_arg": "某个连接指向了此步骤并不具有的输入。",
    "duplicate_arg_binding": "某个输入被连接了多次。",
    "duplicate_edge": "两个步骤之间存在多条连接——请合并为一条。",
    "forward_anchor_invalid": "此自定义步骤未明确声明它转发的是哪个输入。",
    "custom_contract_missing": "无法检查此自定义步骤的输入和输出。",
    "custom_contract_divergent": "此自定义步骤的输入和输出在其代码生成后发生了变化。",
    "missing_input_node": "此步骤需要一个未连接的输入。",
    "cycle_detected": "流水线中存在步骤之间的循环。",
    "disconnected_node": "此步骤未连接到流水线。",
    "content_type_mismatch": "某个连接连接了不兼容的数据类型。",
    "column_unsatisfied": "此步骤缺少所需的列。",
    "params_unfilled": "此步骤的参数尚未配置。",
    "missing_required_param": "有必填参数未设置。",
    "incomplete_object_param": "某个分组参数缺少必填字段。",
    "null_param_value": "某个参数被设为空值，但此步骤需要一个值。",
    "param_type_mismatch": "某个参数的值类型不符合此步骤的要求。",
    "unknown_param_key": "某个分组参数包含此步骤不使用的字段。",
    "invalid_node": "此步骤缺少用于识别它的信息。",
    "duplicate_node_id": "两个步骤使用了相同的标识符——每个步骤都需要有自己的标识符。",
    "unresolved_shared_variable": "此步骤引用了一个尚未定义的共享值。",
    "unknown_node_ref": "此处引用了一个已不存在的步骤。",
    "invalid_edge_target": "某个连接指向了一个无效的步骤。",
    "forward_from_source_file_invalid_chain": "此步骤会传递来自某个输入的数据，但应用无法追溯到该输入。",
    "unused_input_node": "此输入在流水线中未被使用。",
    "missing_required_key": "流水线文件缺少必要的信息。",
    "yaml_syntax_error": "无法读取流水线文件。",
    "top_level_not_mapping": "流水线文件的结构不符合应用的要求。",
    "schema_version_invalid": "无法识别流水线文件的版本。",
    "schema_version_unsupported": "此流水线文件是为应用不支持的版本创建的。",
    "block_not_mapping": "流水线文件中的某个步骤结构不正确。",
    "input_bindings_unsupported": "此流水线文件使用了已不再支持的输入格式。",
    "unknown_block_kind": "流水线文件中的某个步骤类型无法被应用识别。",
    "unknown_tool_slug": "某个步骤引用了一个不存在的工具。",
    "edge_not_mapping": "流水线文件中的某个连接结构不正确。",
    "edge_unknown_key": "某个连接包含应用无法识别的信息。",
    "edge_mapping_missing": "某个连接缺少必要的信息。",
    "edge_mapping_invalid": "某个连接的设置不正确。",
    "edge_endpoint_missing": "某个连接缺少一端。",
    "edge_endpoint_not_scalar": "某个连接同时指向了多个对象。",
    "params_by_block_invalid": "某个步骤的参数格式不正确。",
    "patch_empty_yaml": "流水线文件为空。",
    "patch_root_not_mapping": "流水线文件的结构不符合应用的要求。",
    "patch_no_blocks": "流水线文件不包含任何步骤。",
    "patch_no_input_block": "流水线文件没有可更新的输入步骤。",
    "execution_not_mapping": "流水线的执行设置格式不正确。",
    "execution_unknown_key": "流水线的执行设置中包含无法识别的设置项。",
    "execution_node_timeout_invalid": "步骤时间上限必须是大于零的整数秒。",
    "execution_node_timeout_above_ceiling": "步骤时间上限不能超过 72 小时。"
  },
  "errorStage": {
    "sheet_enumeration_failed": "无法读取此文件中的工作表。",
    "materialize_failed": "无法转换此表。",
    "peek_failed": "无法读取此表。",
    "csv_row_wider_than_header": "某一行的值多于表头。请确保每一行的列数与表头相同，然后重新上传文件。",
    "table_exceeds_memory_budget": "此表过大，无法处理。请将其拆分为行数或列数更少的较小文件，然后重新上传。",
    "enrichment_llm_failed": "无法分析此表。",
    "schema_mismatch": "该表的列与预期不符。",
    "stalled": "此表的准备意外停滞。"
  },
  "error": {
    "generic": "出现问题，请重试。",
    "stageFailed": "此阶段加载失败。",
    "network_error": "无法连接服务器。请检查网络后重试。",
    "request_timeout": "请求超时，请重试。",
    "stale_row_version": "该内容在您编辑时已发生更改。我们已刷新——请检查后重试。",
    "invalid_user_overrides": "无法保存您的更改，因为其格式不符合要求。请刷新页面后重试。",
    "dataset_not_ready": "此表尚未就绪，无法确认。",
    "enrich_in_progress": "此表正在分析中。",
    "dataset_already_uploaded": "此文件已上传。",
    "upload_finalize_in_progress": "此文件仍在登记中。请稍候，然后刷新以确认是否已添加。",
    "upload_blob_properties_not_allowed": "此文件上传时使用了我们无法接受的存储设置。请从此页面重新上传。",
    "unsupported_source_format": "不支持该文件类型。请上传 .parquet、.csv 或 .xlsx 文件。",
    "upload_failed": "上传未完成，请重试。",
    "upload_too_large": "“{{filename}}”超过了单个文件 {{limit_mb}} MB 的限制。",
    "upload_size_mismatch": "上传文件的大小与预期不符，因此未被接受。请重新上传。",
    "empty_file": "文件“{{filename}}”为空。",
    "workspace_not_found": "未找到该工作区。",
    "dataset_not_found": "未找到该表。",
    "case_not_found": "未找到该测试用例。",
    "version_not_found": "未找到该运行。",
    "create_failed": "无法创建，请重试。",
    "delete_failed": "无法删除，请重试。",
    "save_failed": "无法保存您的更改，请重试。",
    "confirm_failed": "无法确认此表，请重试。",
    "reenrich_failed": "无法重新分析此表，请重试。",
    "sample_failed": "无法加载样本行。",
    "sample_read_failed": "无法预览此结果，请重试。",
    "sample_shape_invalid": "无法预览此结果，请重试。",
    "catalog_load_failed": "无法加载您的数据目录。",
    "workspace_load_failed": "无法加载此工作区。",
    "workspaces_load_failed": "无法加载您的工作区。",
    "capabilities_unavailable": "测试场暂时不可用。",
    "turns_load_failed": "无法加载此对话。",
    "turn_send_failed": "您的消息未能发送，请重试。",
    "turn_cancel_failed": "无法停止当前回复。",
    "turn_in_progress": "助手仍在回复中，请稍候。",
    "turn_not_cancellable": "该回复已完成。",
    "attach_too_large": "该文件超过 5 MB 上限。",
    "attach_extract_failed": "无法读取该文件——文件可能已损坏，或其内容无法提取。",
    "attach_unreadable_format": "该文件不包含可读取的文本。",
    "attach_extract_unavailable": "文档读取服务暂时不可用——请稍后重试。",
    "invalid_request": "无法附加该文件，请重试。",
    "runs_load_failed": "无法加载您的运行记录。",
    "run_start_failed": "无法开始运行，请重试。",
    "run_cancel_failed": "无法取消运行。",
    "run_in_progress": "此测试用例已有一次运行正在进行中。",
    "version_cap_exceeded": "此测试用例已达到运行上限。请新建测试用例以继续。",
    "version_already_terminal": "该运行已完成。",
    "pipeline_empty": "尚无可运行的流水线。请先在探索对话中设计一个。",
    "pipeline_invalid": "流水线存在未解决的问题。请先修复再运行。",
    "pipeline_config_yaml_invalid": "无法读取流水线。请在构建中检查。",
    "pipeline_load_failed": "无法加载您的流水线。",
    "pipeline_parse_failed": "无法读取此流水线。",
    "issue_centre_failed": "无法将画布移动到此项。",
    "issue_target_gone": "此项已不在画布上。",
    "structural_pending": "正在保存您的更改。请等待保存完成后再进行其他更改。",
    "structural_save_unconfirmed": "仍在保存您的更改，尚未确认。请等待保存完成。",
    "draft_locked": "助手正在更新此流水线。请在其完成后重试。",
    "functions_load_failed": "无法加载函数面板。",
    "invalid_scope_path": "该领域不在服务菜单中。请从菜单中选择一个领域。",
    "pipeline_yaml_unparseable": "此修改无法解析为流水线，因此未保存。请撤销修改或修正结构。",
    "scope_vocabulary_unavailable": "验证领域所需的服务菜单暂时不可用。请稍后重试。",
    "reggie_write_forbidden": "您无法修改此测试工作区。请联系该模型的所有者或管理员，在该模型的“访问”标签页中授予您“协作者”权限。",
    "reggie_sso_required": "请使用您的组织账户登录后再使用测试场。",
    "reggie_upstream_unreachable": "暂时无法连接测试场。请稍后重试。",
    "webhook_url_invalid": "Webhook URL 必须是可从公网访问的绝对 https:// 地址。",
    "webhook_url_unverified": "暂时无法验证该 Webhook 地址。请稍后再次保存。",
    "input_source_not_owned": "您的账户无法访问此流水线的输入文件。请重新附加源数据后再运行。",
    "speech_disabled": "语音输入暂不可用。",
    "speech_rate_limited": "语音消息过多。请稍等片刻后重试。",
    "speech_audio_invalid": "无法读取录音。请重新录制您的消息。",
    "speech_no_speech": "未检测到语音。请重试。",
    "speech_upstream_failed": "无法转写您的语音。请重试。",
    "speech_upstream_timeout": "转写超时。请重试。",
    "speech_unsupported": "此浏览器不支持语音输入。",
    "speech_mic_denied": "麦克风访问被拒绝。请在浏览器设置中允许访问后重试。",
    "speech_mic_unavailable": "未找到麦克风。请连接麦克风后重试。",
    "speech_mic_busy": "无法打开麦克风。请检查其他应用是否正在使用它。",
    "speech_cancelled": "语音输入已取消。",
    "speech_composer_disabled": "聊天正忙，语音输入已停止。您的草稿未更改。",
    "speech_request_timeout": "转写超时。请重试。",
    "speech_request_failed": "语音输入失败。请重试。",
    "speech_send_failed": "无法发送您的语音消息。请重试。",
    "request_body_too_large": "该请求过大。"
  }
}
